import { cn } from "@/lib/cn";

interface Table1Item {
	text: string,
	url?: string,
}

interface Table1Props {
	header: string,
	items: Table1Item[],
	className?: string,
}

// Table with one column
export function Table1({ header, items, className }: Table1Props) {
	return (
		<table className={cn("border-collapse border border-border select-none", className)}>
			<thead>
				<tr>
					<th className="text-left border border-border px-2 py-1 font-bold">{header}</th>
				</tr>
			</thead>

			<tbody>
				{items.map((item, index) => (
					<tr key={index}>
						<td className="border border-border px-2 py-1">
							{item.url ? <a href={item.url} className="font-semibold">{item.text}</a> : item.text}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	);
}

interface Table2Item {
	title: string,
	url?: string,
	description: string,
}

interface Table2Props {
	header: string[],
	items: Table2Item[],
	className?: string,
}

// Table with two columns
export function Table2({ header, items, className }: Table2Props) {
	return (
		<table className={cn("border-collapse border border-border select-none ", className)}>

			<thead>
				<tr>
					{header.map((h, index) => (
						<th key={index} className="text-left border border-border px-2 py-1 font-bold">
							{h}
						</th>
					))}
				</tr>
			</thead>

			<tbody>
				{items.map((item, index) => (
					<tr key={index}>
						<td className="border border-border px-2 py-1">
							<a href={item.url} className="font-bold">{item.title}</a>
						</td>
						<td className="border border-border px-2 py-1">{item.description}</td>
					</tr>
				))}
			</tbody>
		</table>
	);
}
